/**
 * [CurveBeamAI] Singleton service that holds the active workflow preset.
 *
 * Activated early in Mode.tsx from the `workflow` URL param, then read by
 * onModeEnter, layoutTemplate, and applyCurveBeamPostInit to apply the
 * preset's toolbar/panel/header/customization overrides.
 */

import { WorkflowPreset, WorkflowId } from './types';
import { workflowPresetRegistry } from './registry';

let activePreset: WorkflowPreset | null = null;

export const WorkflowPresetService = {
  /**
   * Look up the workflow ID in the registry and store it as the active preset.
   * Falls back to 'default' if the ID is unknown or not provided.
   */
  activate(workflowId?: string): WorkflowPreset {
    const id = (workflowId ?? 'default') as WorkflowId;
    const preset = workflowPresetRegistry.get(id) ?? workflowPresetRegistry.get('default')!;
    activePreset = preset;
    return preset;
  },

  getActivePreset(): WorkflowPreset | null {
    return activePreset;
  },

  /** Reset to null (used on mode exit) */
  reset(): void {
    activePreset = null;
  },
};
